'use client';

import React from 'react';
import styled from 'styled-components';

export interface DashboardHeaderProps {
  title: string;
  description: string;
  className?: string;
}

const Header = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #101018;
  margin: 0 0 8px 0;
`;

const Description = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  color: #6E6E6E;
  margin: 0;
`;

/**
 * DashboardHeader Component
 * 
 * A header component for dashboard pages with title and description.
 * 
 * @component
 * @example
 * ```tsx
 * <DashboardHeader
 *   title="Monitors"
 *   description="Track uptime, response time, and health status"
 * />
 * ```
 */
export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  description,
  className,
}) => {
  return (
    <Header className={className}>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Header>
  );
};

export default DashboardHeader;

